import {
  ADD_ORDER_POSITION,
  CHANGE_COUNT,
  REMOVE_ORDER_POSITION
} from "../actions/order";

const orderReducer = (state = { items: [] }, action) => {
  switch (action.type) {
    case ADD_ORDER_POSITION:
      return Object.assign({}, state, {
        items: [...state.items, action.value]
      });
    case CHANGE_COUNT:
      return Object.assign({}, state, {
        items: state.items.map(item => {
          if (item.id === action.id) {
            item.count = action.count;
          }
          return item;
        })
      });
    case REMOVE_ORDER_POSITION:
      return Object.assign({}, state, {
        items: state.items.filter(({ id }) => id !== action.value)
      });
    default:
      return state;
  }
};

export default orderReducer;
